module.exports = __webpack_public_path__ + "static/media/Duan4.c7b04da5.png";